import { lazy } from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const BenefitsListPage = lazy(() => import('modules/benefits/pages/MyBenefits/MyBenefitsList'))
const PerksPage = lazy(() => import('modules/benefits/pages/MyBenefits/PerksPage'))

const RootPage = lazy(() => import('modules/benefits/pages/MyBenefits/RootPage'))

const BenefitsRootPage = lazy(() => import('modules/benefits/pages/MyBenefits/MyBenefitsHomePage'))

export const myBenefitsRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.myBenefits.path,
    handle: {
      module: 'my_benefits',
      meta: ({ session }) => {
        const isSpanishLegalEntity = session?.employee?.legalEntity?.country === 'es'

        const baseMeta = {
          title: i18n.t('benefits.my_module_name'),
          description: i18n.t('benefits.my_module_description'),
        }

        if (!isSpanishLegalEntity) {
          return baseMeta
        }

        return {
          ...baseMeta,
          subNavigation: [
            {
              title: i18n.t('benefits.my_benefits.spending.title'),
              href: navigation.myBenefits.fullPath(),
              index: true,
            },
            {
              title: i18n.t('benefits.my_benefits.catalogue.title'),
              href: navigation.myBenefits.benefits.fullPath(),
            },
          ],
        }
      },
    },
    element: <RootPage />,
    children: [
      {
        index: true,
        element: <BenefitsRootPage />,
      },
      {
        path: navigation.myBenefits.benefits.path,
        element: <BenefitsListPage />,
        handle: {
          meta: () => ({
            title: i18n.t('benefits.my_benefits.catalogue.title'),
            description: i18n.t('benefits.my_benefits.my_benefits_list.description'),
          }),
        },
        children: [
          {
            path: navigation.myBenefits.benefits.perks.path,
            element: <PerksPage />,
            handle: {
              resource: true,
              meta: () => ({
                title: i18n.t('benefits.my_benefits.perk.title'),
                description: i18n.t('benefits.my_benefits.perk.description'),
              }),
            },
          },
        ],
      },
    ],
  },
]
